import { render, staticRenderFns } from "./CabinetPowerPricing.vue?vue&type=template&id=20fd4dea&"
import script from "./CabinetPowerPricing.vue?vue&type=script&lang=js&"
export * from "./CabinetPowerPricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports